import { Panel } from "rsuite";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import "./ShortcutPanel.css";

export const types = {
  primary: "primary",
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
};

const ShortCutPanel = ({ icon, type, title, paragraph, href, className }) => {
  return (
    <Panel className={"content p-0 shortcut-card " + (className || "")}>
      <Link to={href} className="shortcut-link">
        <span className={"shortcut-icon shortcut-icon--" + type}>{icon}</span>
        <span className="shortcut-body">
          <span className="shortcut-title">{title}</span>
          <span className="shortcut-sub">{paragraph}</span>
        </span>
        <span className="shortcut-arrow">
          <FaChevronRight />
        </span>
      </Link>
    </Panel>
  );
};

export default ShortCutPanel;
